import React, { useState, useEffect } from 'react';
import { PrimaryButton, Overlay, ModalHeader } from '../../../components';
import { motion } from 'framer-motion';

import ChangeLicenseTypeIcon from '../../../assets/icons/change-accout-type.svg';
import { Select } from 'antd';

const licenseTypeOptions = [
  { value: 1, label: 'Dx Demo' },
  { value: 2, label: 'Portal Demo' },
  { value: 3, label: 'Dx Basic' },
  { value: 4, label: 'Portal Basic' },
  { value: 5, label: 'AI Plus' },
  { value: 6, label: 'Enterprise Plus' },
];

const getLicenseTypeLabel = (licenseTypeId) => {
  const match = licenseTypeOptions.find((option) => option.value === Number(licenseTypeId));
  return match ? match.label : '--';
};

const ChangeLicenseTypeModal = ({ openModal, onClose, details, updateLicenseType }) => {
  const [licenseTypeValue, setLicenseTypeValue] = useState();

  useEffect(() => {
    if (details) {
      setLicenseTypeValue(details.license_type_id ? Number(details.license_type_id) : undefined);
    }
  }, [details]);

  const handleSave = () => {
    if (!licenseTypeValue) {
      return;
    }
    updateLicenseType({
      dxAccountId: details.dx_account_id,
      licenseType: licenseTypeValue,
    });
    onClose(false);
  };

  return (
    openModal && (
      <div className="form-container">
        <Overlay />
        <div className="prompt new-dx-account change-license-type-modal">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
          >
            <ModalHeader
              title="Change License Type"
              onClick={() => onClose(false)}
              img={ChangeLicenseTypeIcon}
            />
            <div className="modal_middle site-admin">
              <div className="change-license-type-details">
                <div className="detail-row">
                  <span className="detail-label">Account ID :</span>
                  <span className="detail-value">{details?.dx_account_id}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Admin Email :</span>
                  <span className="detail-value">{details?.admin_email_id}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Current License Type :</span>
                  <span className="detail-value">
                    {getLicenseTypeLabel(details?.license_type_id)}
                  </span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Change License Type :</span>
                  <Select
                    placeholder="License Type"
                    className="dropdown"
                    value={licenseTypeValue}
                    onChange={(e) => setLicenseTypeValue(e)}
                  >
                    {licenseTypeOptions.map((type) => (
                      <Select.Option key={type.value} value={type.value}>
                        {type.label}
                      </Select.Option>
                    ))}
                  </Select>
                </div>
              </div>
              <div className="prompt-bottom" style={{ marginTop: 0 }}>
                <PrimaryButton label="Save" onClick={handleSave} extraClass="prompt-done" />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    )
  );
};

export default ChangeLicenseTypeModal;
